import { useEffect, useState } from 'react';

const canQuery = (): boolean => typeof window !== 'undefined' && typeof window.matchMedia === 'function';

export const useMediaQuery = (query: string, fallback = true): boolean => {
  const [matches, setMatches] = useState(() => (canQuery() ? window.matchMedia(query).matches : fallback));

  useEffect(() => {
    if (!canQuery()) {
      return undefined;
    }
    const media = window.matchMedia(query);
    const update = () => setMatches(media.matches);
    update();
    media.addEventListener('change', update);
    return () => media.removeEventListener('change', update);
  }, [query]);

  return matches;
};
